export default __webpack_public_path__ + "static/experience-307e57b71585204e71b1c51b972b44c5.png";